// Kiwi.com upsell cards shown on flight results (grid CTA + deals banner).

const ICON_EXTERNAL = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>`;
const ICON_ARROW = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden><path d="M5 12h14M12 5l7 7-7 7"/></svg>`;
const ICON_PLANE = `<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5L21 16z"/></svg>`;

function esc(s) {
  return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

/** First-slot grid card — same shell as a flight result, links out to Kiwi. */
export function renderMoreRoutesCard(deeplink) {
  const el = document.createElement('a');
  el.href = deeplink || '#';
  el.target = '_blank';
  el.rel = 'noopener noreferrer';
  el.className = 'fcard fcard--more-routes';
  el.setAttribute('aria-label', 'More routes available on Kiwi.com');
  el.innerHTML = `
    <div class="fcard-head">
      <div>
        <div class="city">More routes available</div>
        <div class="date">Includes Ryanair &amp; more</div>
      </div>
      <div class="more-routes-icon" aria-hidden="true">${ICON_PLANE}</div>
    </div>
    <p class="more-routes-text">We only show a selection here. Open Kiwi.com to browse every matching route for your search.</p>
    <span class="book">See more on Kiwi ${ICON_ARROW}</span>`;
  return el;
}

/** Banner below the cheapest grid. Stronger CTA when the search returned nothing. */
export function renderDealsCardHTML(deeplink, { empty = false } = {}) {
  const title = empty ? 'No flights matched your filters' : 'Looking for more deals?';
  const text = empty
    ? "We couldn't find flights that fit this search on Getting Away. Try the same trip on Kiwi.com — including Ryanair and other airlines we can't list here."
    : "We can't show flights from Ryanair, but if you click below you can see all the deals available through Kiwi.com";
  const label = empty ? 'Search these dates on Kiwi.com' : 'Explore more deals';
  const emptyClass = empty ? ' fr-deals-card--empty' : '';

  return `<a href="${esc(deeplink)}" target="_blank" rel="noopener noreferrer" class="fr-deals-card${emptyClass}">
    <div class="fr-deals-card__glow" aria-hidden="true"></div>
    <p class="fr-deals-card__badge">Includes Ryanair &amp; more</p>
    <p class="fr-deals-card__title">${title}</p>
    <p class="fr-deals-card__text">${text}</p>
    <span class="fr-deals-card__link">
      <span class="fr-deals-card__link-label">${label}</span>
      ${ICON_EXTERNAL}
    </span>
  </a>`;
}
